import React from 'react';
import { Modal as HenModal } from '@highereducation/hen-ui';
import { useDynamicExperienceContext } from '@de/providers/DynamicExperienceProvider';
import { parseHtmlString } from '@de/shared/utils';
import { Button, Text } from '@highereducation/hen-ui';

export interface ModalProps {
  modal?: {
    enable?: boolean;
    title?: string;
    content?: string;
    buttonText?: string;
  };
  openModal: boolean;
}

/**
 * TCPA Modal component for consent
 * Uses the HEN Design System Modal composite component.
 */
export const Modal: React.FC<ModalProps> = ({ modal, openModal }) => {
  const { handleTCPA, handleStepForward } = useDynamicExperienceContext();

  if (!modal?.enable) {
    return null;
  }

  return (
    <HenModal
      open={openModal}
      onOpenChange={(open) => {
        if (!open) {
          handleTCPA(false);
        }
      }}
    >
      <HenModal.Content size='sm'>
        <HenModal.Header>
          <HenModal.Title>{modal?.title || ''}</HenModal.Title>
        </HenModal.Header>
        <Text
          variant='b5'
          color='subtext'
          className='de-modal-content px-lg py-md'
        >
          {parseHtmlString(modal.content || '')}
        </Text>
        <HenModal.Footer>
          <Button
            variant='primaryFill'
            className='w-full'
            onClick={() => {
              handleTCPA(true);
              handleStepForward();
            }}
          >
            {modal?.buttonText || 'Accept'}
          </Button>
        </HenModal.Footer>
      </HenModal.Content>
    </HenModal>
  );
};

export default Modal;
